// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.rpc.auth

import org.multipaz.cbor.DataItem
import org.multipaz.rpc.handler.RpcDispatcher
import org.multipaz.rpc.handler.RpcNotifier
import org.multipaz.rpc.handler.RpcReturnCode
import org.multipaz.cbor.Bstr
import org.multipaz.rpc.auth.ClientRegistration
import org.multipaz.rpc.client.RpcStub
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.buildCborArray
import org.multipaz.device.DeviceAttestation
import org.multipaz.cbor.Cbor
import org.multipaz.device.toDataItem


class ClientRegistrationStub(
    endpoint: String,
    dispatcher: RpcDispatcher,
    notifier: RpcNotifier,
    state: DataItem = Bstr(byteArrayOf())
): RpcStub(endpoint, dispatcher, notifier, state), ClientRegistration {

    override suspend fun challenge(): ByteString {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "challenge", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        return ByteString(rpcResponse[3].asBstr)
    }

    override suspend fun register(deviceAttestation: DeviceAttestation): String {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(deviceAttestation.toDataItem())
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "register", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        return rpcResponse[3].asTstr
    }

    companion object {
        fun fromDataItem(
            data: DataItem,
            dispatcher: RpcDispatcher,
            notifier: RpcNotifier,
        ): ClientRegistrationStub {
            val endpoint = data["endpoint"].asTstr
            val state = data["state"]
            return ClientRegistrationStub(endpoint, dispatcher, notifier, state)
        }

        fun fromCbor(
            data: ByteArray,
            dispatcher: RpcDispatcher,
            notifier: RpcNotifier,
        ): ClientRegistrationStub {
            val dataItem = Cbor.decode(data)
            return fromDataItem(dataItem, dispatcher, notifier)
        }
    }
}
